import React from "react";
import { useIsPWAInstalled } from "../lib/pwa";
import Logo from "./Logo";
import InstallCTA from "./InstallCTA";

/**
 * Full-screen install gate.
 *
 * Design goal per the Feb-2026 install-experience redesign:
 *   the blue install button is the ONLY action the user should see.
 *   No Step 1/Step 2 walkthroughs, no share-icon diagrams, no menu
 *   instructions. The button itself detects the platform and does
 *   the maximum-possible one-tap install action.
 */
export default function InstallGate({ children }) {
  const installed = useIsPWAInstalled();
  if (installed) return children;

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-50 grid place-items-center p-6">
      <div className="w-full max-w-md text-center">
        <div className="flex items-center justify-center mb-8">
          <Logo size={72} withWordmark />
        </div>
        <InstallCTA />
      </div>
    </div>
  );
}
